module.exports = __webpack_public_path__ + "media/images/icons/spotify-podcast-lg-28c2ea5e8a27b60fd563404f2cdf437a.svg";